import React, { useEffect, useContext, useState } from 'react';
import {GlobalContext} from "global-context";
import { useHistory } from 'react-router-dom'
import { GET_QUOTES } from "app/queries/Quote";
import {useMutation} from "@apollo/react-hooks";
import ReactTable from 'react-table-6'
import moment from 'moment'
import {toast} from "react-toastify";
import { QuoteI } from './'

export function Quotes() {
  const globalContext = useContext(GlobalContext)
  const history = useHistory();
  const [ getQuotes ] = useMutation(GET_QUOTES)

  const [quotes, setQuotes] = useState<QuoteI[] | undefined>([])
  const [showSubmitted, setShowSubmitted] = useState<boolean>(false)

  useEffect(() => {
    fetchQuotes();
  }, [])

  async function fetchQuotes() {
    try{
      const response = await getQuotes();
      setQuotes(response.data.getQuotes.quotes.reverse())
    } catch(e) {
      toast.error('Something went wrong fetching the data, please try again later.')
    }
  }

  const columns = [
    {
      Header: 'Name',
      accessor: 'firstName'
    },
    {
      Header: 'Email Address',
      accessor: 'email',
    },
    {
      Header: 'Phone',
      accessor: 'phone',
    },
    {
      Header: 'Group Size',
      accessor: 'groupSize'
    },
    {
      Header: 'Distance',
      accessor: 'distanceInMiles',
      Cell: (row: any) => `${row.value} miles`
    },
    {
      Header: 'Pick Up',
      accessor: 'pickUpAddress'
    },
    {
      Header: 'Drop Off',
      accessor: 'dropOffAddress'
    },
    {
      Header: 'Total Cost',
      accessor: 'quoteAmount',
      Cell: (row: any) => `$${Math.round(row.value)}`
    },
    {
      Header: 'Date',
      accessor: 'createdAt',
      Cell: (row: any) => moment(row.value).format('MMMM DD, YYYY -  hh:mm A')
    }
  ]

  if(!globalContext.user.token) history.push('/login')
  return (
      <div className='mt-0 mt-md-5'>
        <div className='row'>
          <div className={`col-6 table-option text-center ${!showSubmitted && 'active'}`} onClick={() => setShowSubmitted(false)}>Calculated</div>
          <div className={`col-6 table-option text-center ${showSubmitted && 'active'}`} onClick={() => setShowSubmitted(true)}>Submitted</div>
        </div>
        <ReactTable
            data={showSubmitted ? quotes?.filter(x => x.rideRequested) : quotes?.filter(x => !x.rideRequested)}
            columns={columns}
        />
      </div>
  )
}